require('./expensesByCategoryTable.scss');

// @ vendors
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

// @ utilities
import { formatAmountObject, getPlainAmountObject } from 'utilities/currencyHelper';
import { getFirstNChars, getLastNChars } from 'utilities/stringHelper';
const { FormattedText, getLanguage } = require('core/i18n').i18n;

// @ components
import { LabelDate } from 'commonsComponents/labelDate';
import { OneLineSymbolAmount } from 'commonsComponents/oneLineSymbolAmount';
import { CategoriesModal } from 'components/commons/categoriesModal/categoriesModal';

// @ commons
import { OKTable } from 'commonsComponents/OKTable';
import { OKTableRow } from 'commonsComponents/OKTableRow';
import { OKTableCell } from 'commonsComponents/OKTableCell';

// @ actions
import { open } from 'actions/categoryUpdate';

// @ constants
import { DATE_FORMAT_DAY_MONTH } from 'constants/index';
import { LABEL_DATE_TODAY, LABEL_DATE_YESTERDAY } from 'constants/commonsComponents';

class ExpensesByCategoryTable extends Component {

    buildColumnsTable() {
        return (
            <thead>
                <OKTableRow asHeader={true}>
                    <OKTableCell asHeader={true}>
                        <FormattedText value="movementsByCategory-date" />
                    </OKTableCell>
                    <OKTableCell asHeader={true}>
                        <FormattedText value="movementsByCategory-contract" />
                    </OKTableCell>
                    <OKTableCell asHeader={true}>
                        <FormattedText value="movementsByCategory-subCategory" />
                    </OKTableCell>
                    <OKTableCell asHeader={true}>
                        <FormattedText value="movementsByCategory-description" />
                    </OKTableCell>
                    <OKTableCell asHeader={true} className="expenses-by-category-row--align-right">
                        <FormattedText value="movementsByCategory-amount" />
                    </OKTableCell>
                    {/* {
                        this.props.canChangeCategory ?
                            <OKTableCell className="expenses-by-category-row__expand" asHeader={true}>
                                <span></span>
                            </OKTableCell> : null
                    } */}
                </OKTableRow>
            </thead>
        );
    }

    handleOpenCategoriesModal(expense, index) {
        const { openCategoriesModal } = this.props;

        openCategoriesModal(
            expense.get('tipoCuenta'),
            expense.get('contractId'),
            index,
            expense.get('category'),
            expense.get('subcategory'),
            expense.get('concept'),
            expense.get('fecha'),
            expense.get('monto'),
            expense.get('categoryCode'),
            expense.get('subcategoryCode')
        );
    }

    getAccountTypeIcon = type => type === 0 ? 'rebrand-accounts' : 'rebrand-credit-card';

    getTitle = expense => {
        let title;

        if (!expense.get('description')) return '-'

        if( typeof expense.get('description') === 'string') {
            title = getFirstNChars(expense.get('description').trim(), 30);
        }
        else if ( typeof expense.get('description').get('current') === 'string') {
            title = getFirstNChars(expense.get('description').get('current').trim(), 30);
        } else {
            title = "-";
        }
        return title;
    }

    buildContentTable() {
        const { canChangeCategory } = this.props;

        let isExpanded = false;
        let title;
        let response = this.props.expensesByCategory.size > 0 && this.props.expensesByCategory.map((expense, index) => {
            const accountTypeIcon = this.getAccountTypeIcon(expense.get('tipoCuenta'));
            const plainAmountObject = getPlainAmountObject({ amount: expense.get('monto'), currency: expense.get('currency') });
            const language = getLanguage();
            title = this.getTitle(expense)

            return (
                <OKTableRow key={index} isExpanded={isExpanded}>
                    <OKTableCell className="expenses-by-category-row__date">
                        <LabelDate
                            date={expense.get('fecha')}
                            format={DATE_FORMAT_DAY_MONTH}
                            language={language}
                            today={LABEL_DATE_TODAY}
                            yesterday={LABEL_DATE_YESTERDAY}
                        />
                    </OKTableCell>
                    <OKTableCell className="expenses-by-category-row__contract">
                        <i className={`expenses-by-category-row__icon icon ${accountTypeIcon}`}
                            onClick={this.props.canChangeCategory ? () => this.handleOpenCategoriesModal(expense, index) : null}
                        />
                        <span className="expenses-by-category-table__contract-title"> { title } </span>
                        <span className="expenses-by-category-table__contract-title--small"> { getLastNChars(expense.get('contract')) } </span>
                    </OKTableCell>
                    <OKTableCell className="expenses-by-category-row__subcategory">
                        { <FormattedText value={`categorized-${expense.get('subcategory')}`} /> }
                    </OKTableCell>
                    <OKTableCell className="expenses-by-category-row__description"> { expense.get('concept') } </OKTableCell>
                    <OKTableCell className="expenses-by-category-row__amount expenses-by-category-row--align-right">
                        <OneLineSymbolAmount
                            amountObject={plainAmountObject}
                            language={language}
                            amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
                    </OKTableCell>
                    {
                        canChangeCategory ?
                            <OKTableCell className="expenses-by-category-row__expand-button">
                                <div
                                    className="expenses-by-category-row__icon-wrapper"
                                    onClick={() => this.handleOpenCategoriesModal(expense, index)}>
                                    <i className="icon icon-editar expenses-by-category-row__icon-wrapper__icon" />
                                </div>
                            </OKTableCell> : null
                    }
                </OKTableRow>
            );
        });

        return (
            <tbody>
                {response}
            </tbody>
        );
    }

    render() {
        const tableComponents = [
            this.buildColumnsTable(),
            this.buildContentTable(),
        ];
        /**
         * @horizontal-scroll
         *
         * The result table has a container with an horizontal scroll and the
         * inner content is set to a fix width according to its size in
         * desktop.
         */

        return (
            <div style={{ overflowX: 'auto' }}>
                <section className="expenses-by-category-table">
                    <CategoriesModal byCategory />
                    <OKTable>
                        {tableComponents}
                    </OKTable>
                </section>
            </div>
        );
    }
}

ExpensesByCategoryTable.propTypes = {
    immAccounts: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    expensesByCategory: PropTypes.object.isRequired,
    openCategoriesModal: PropTypes.func,
    canChangeCategory: PropTypes.bool
};

ExpensesByCategoryTable.defaultProps = {
    canChangeCategory: true
}

module.exports = connect(null, {
    openCategoriesModal: open
})(ExpensesByCategoryTable);
